//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "app",
  data () {
    return {
      show: false,
      imgUrl: "",
      imgUrl1: "",
      freemaVisable: false,
      freemaTxt: "",
      closeImg: false,
      closeImg1: false,
      erweimaVisable: false,
      title: "",
      content: "",
      price: '',
      wxNumText: "", //微信号
      btnText: "",
      click: "",
      erweimaImg: "",
      wxNumVisable: false,
      wxNumDesc: "",
      WxNum: "",
      wxDescColor: '',
      copyBgColor: "",
      copyTxtColor: '',
      imgWidth: "3.6rem",
      imgSrc: false,
      downAppVisable: true //是否显示下载app的button
    };
  },
  created () { },
  methods: {
    btnClick () {
      this.click();
      this.show = false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/popup/index.vue